import { FormHelpText, FormInput } from '@spotify-internal/encore-web';
import { useT } from '@spotify-internal/i18n-core';

interface FilenameInputProps {
  value: string;
  defaultExportFileName: string;
  handleChange: (e: React.ChangeEvent<any>) => void;
  handleBlur: (e: React.ChangeEvent<any>) => void;
  errors: string | undefined;
}

export const FilenameInput = ({
  value,
  defaultExportFileName,
  handleChange,
  handleBlur,
  errors,
}: FilenameInputProps) => {
  const t = useT();

  return (
    <>
      <FormInput
        type="text"
        id="exportFileName"
        name="exportFileName"
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={defaultExportFileName}
      />
      {errors ? (
        <FormHelpText id="exportFileName-error" error>
          {errors}
        </FormHelpText>
      ) : (
        <FormHelpText id="exportFileName-message">
          {t(
            'atlas.labels.optional_text',
            'Optional',
            'Subtext that indicates a field is optional',
          )}
        </FormHelpText>
      )}
    </>
  );
};
